export default function HomeIcon({active = false}) {
    return <img src="/assets/images/img_mail.svg" alt="Home" />
}